import * as React from "react";
import * as PropTypes from "prop-types";
import { observer } from "mobx-react";
import { canWorkflow } from "../../social/publishing/postActions/ToolbarActions";
import WorkflowCategoryChip from "./WorkflowCategoryChip";
import {getCategory} from "../models";

/**
 * WorkflowSummaryLink
 * @param {WorkflowTask} workflowTask
 */
const WorkflowSummaryLink = observer(function WorkflowLink({ workflowTask }) {
  if (!workflowTask) return undefined;
  const categoryName = workflowTask.category;
  const prefix = getCategory(categoryName).prefix;
  const prefixFriendlyId = `${prefix}-${workflowTask.friendlyId}`;
  const taskName = workflowTask.content.taskName;
  const taskSuffix = workflowTask.contentEditHistory.length > 0 ? "Task Updated" : "Task Created";

  const link = canWorkflow()
    ? (<a className="btn btn-link" href={`/#/workflow2/view-task/${prefixFriendlyId}`}>{prefixFriendlyId}</a>)
    : (
      <button className="btn btn-link disabled" title="Contact your account administrator for access to workflow" disabled>
        {prefixFriendlyId}
      </button>
    );

  return (
    <div className="d-inline-flex flex-row align-items-center">
      <WorkflowCategoryChip category={workflowTask.category} /> {" "}
      {taskName} {taskSuffix} {link}
    </div>
  );
});

WorkflowSummaryLink.propTypes = {
  workflowTask: PropTypes.object.isRequired
};

export default WorkflowSummaryLink;
